import translationEN from './en/translation';
import translationEL from './el/translation';
import errorsEN from './en/errors.json';
import errorsEL from './el/errors.json';

export default {
  en: {
    translation: translationEN,
    ERROR: errorsEN
  },
  el: {
    translation: translationEL,
    ERROR: errorsEL
  }
};
